import app from 'flarum/forum/app';

/**
 * Nome e ícone do chat configuráveis pelo admin, lidos pelo botão do header e
 * pela gaveta.
 */

/** Nome do chat; sem configuração, usa a tradução padrão. */
export function chatTitle() {
  var _app$forum$attribute;
  const custom = ((_app$forum$attribute = app.forum.attribute('ramon-chat.title')) != null ? _app$forum$attribute : '').trim();
  if (custom !== '') return custom;
  return app.translator.trans('ramon-chat.forum.nav.chat', {}, true);
}

/**
 * Classe Font Awesome do ícone, ou null quando o admin o desligou. Null em vez de
 * string vazia obriga quem chama a decidir o que renderizar sem ícone.
 */
export function chatIcon() {
  var _app$forum$attribute2;
  if (app.forum.attribute('ramon-chat.showIcon') === false) return null;
  const icon = ((_app$forum$attribute2 = app.forum.attribute('ramon-chat.icon')) != null ? _app$forum$attribute2 : '').trim();
  return icon === '' ? 'fas fa-comments' : icon;
}
flarum.reg.add('ramon-chat', 'forum/utils/branding', { chatTitle: chatTitle,chatIcon: chatIcon, });